import { BulbFilled, BulbOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import React from 'react';

interface ThemeSwitcherProps {
  theme: 'dark' | 'light';
  onChange: () => void;
}
export default function ThemeSwitcher(props: ThemeSwitcherProps) {
  return (
    <Button
      type="text"
      icon={props.theme === 'dark' ? <BulbFilled /> : <BulbOutlined />}
      title={props.theme === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'}
      onClick={() => props.onChange()}
    />
  );
}
